import React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton } from '@mui/material';

const CopyButtonUI = (props) => {
  return (
    <IconButton
      size="small"
      sx={{
        margin: '3px',
        color: 'white',
        padding: '3px',
        backgroundColor: '#7d9eb0',
        '&:hover': {
          backgroundColor: 'grey.400',
        },
      }}
      {...props}
    >
      <ContentCopyIcon fontSize="inherit" />
    </IconButton>
  );
};

export default CopyButtonUI;
